module.exports = "/_next/static/images/MakeEveryInteractionMeaningful@2x-4ec4ab34553c0ea8008784d877a764d1.png";